<template>
    <div>
        <form action="put" @submit.prevent="submit">
            <div class="row">
                <div class="form-group col-xl-3 col-lg-4 col-md-6">
                    <label>Приемный пункт</label>
                    <input type="text" class="form-control" v-model="partner.Reception">
                </div>
                <div class="form-group col-xl-3 col-lg-4 col-md-6">
                    <label>Плательщик</label>
                    <input type="text" class="form-control" v-model="partner.Payer">
                </div>
                <div class="form-group col-xl-3 col-lg-4 col-md-6">
                    <label>ТОРО</label>
                    <input type="text" class="form-control" v-model="partner.Toro">
                </div>
                <div class="form-group col-xl-3 col-lg-4 col-md-6">
                    <label>ФИО</label>
                    <input type="text" class="form-control" v-model="partner.Fio">
                </div>
            </div>
            <div class="row">
                <div class="form-group col-xl-3 col-lg-4 col-md-6">
                    <label>Телефон</label>
                    <input type="text" class="form-control" v-model="partner.Phone">
                </div>
                <div class="form-group col-xl-3 col-lg-4 col-md-6">
                    <label>Телефон 2</label>
                    <input type="text" class="form-control" v-model="partner.DirectorPhone">
                </div>
            </div>
            <div class="row">
                <div class="form-group col-xl-3 col-lg-4 col-md-6">
                    <label>Город</label>
                    <v-select v-model="partner.CityId" label="Name"
                              :reduce="item => item.Id"
                              :options="cities">
                        <template slot="no-options">
                            начните вводить...
                        </template>
                        <template slot="option" slot-scope="option">
                            <div class="d-center">
                                {{ option.Name }}
                            </div>
                        </template>
                        <template slot="selected-option" slot-scope="option">
                            <div class="selected d-center">
                                {{ option.Name }}
                            </div>
                        </template>
                        <template #search="{attributes, events}">
                            <input
                                    class="vs__search"
                                    :required="!partner.CityId"
                                    v-bind="attributes"
                                    v-on="events"
                                    v-on:keydown.enter.prevent
                            />
                        </template>
                    </v-select>
                </div>
              <div class="form-group col-xl-3 col-lg-4 col-md-6">
                <label>Категория</label>
                <v-select
                  v-model="partner.CustomerCategoryId"
                  :options="partner.CustomerCategories"
                  :taggable="true"
                  :createOption="createCustomerCategory"
                  label="Name"
                  :reduce="item => item.Id"
                  style="min-width: 200px"
                >
                  <template #search="{attributes, events}">
                    <input
                      class="vs__search"
                      :required="!partner.CustomerCategoryId"
                      v-bind="attributes"
                      v-on="events"
                    />
                  </template>
                </v-select>
              </div>
            </div>
            <div class="row">
                <div class="form-group col-xl-3 col-lg-4 col-md-6">
                    <label>Объезд партнера</label>
                    <v-select v-model="partner.TourId" label="Name" :filterable="false"
                              :reduce="tour => tour.Id"
                              :options="partnerTours">
                        <template slot="no-options">
                            начните вводить...
                        </template>
                        <template slot="option" slot-scope="option">
                            <div class="d-center">
                                {{ option.Name }}
                            </div>
                        </template>
                        <template slot="selected-option" slot-scope="option">
                            <div class="selected d-center">
                                {{ option.Name }}
                            </div>
                        </template>
                        <template #search="{attributes, events}">
                            <input
                                    class="vs__search"
                                    :required="!partner.TourId"
                                    v-bind="attributes"
                                    v-on="events"
                                    v-on:keydown.enter.prevent
                            />
                        </template>
                    </v-select>
                </div>
                <div class="form-group col-xl-3 col-lg-4 col-md-6">
                    <label>Прайс лист</label>
                    <v-select v-model="partner.PriceListId" label="Name" :filterable="false"
                              :reduce="item => item.Id"
                              :options="partnerPriceLists">
                        <template slot="no-options">
                            начните вводить...
                        </template>
                        <template slot="option" slot-scope="option">
                            <div class="d-center">
                                {{ option.Name }}
                            </div>
                        </template>
                        <template slot="selected-option" slot-scope="option">
                            <div class="selected d-center">
                                {{ option.Name }}
                            </div>
                        </template>
                        <template #search="{attributes, events}">
                            <input
                                    class="vs__search"
                                    :required="!partner.PriceListId"
                                    v-bind="attributes"
                                    v-on="events"
                                    v-on:keydown.enter.prevent
                            />
                        </template>
                    </v-select>
                </div>
                <div class="form-group col-xl-3 col-lg-4 col-md-6">
                    <label>Тип оплаты</label>
                    <v-select v-model="partner.PaymentTypeId" label="Name" :filterable="false"
                              :reduce="item => item.Id"
                              :options="$root.paymentTypes">
                        <template slot="no-options">
                            начните вводить...
                        </template>
                        <template slot="option" slot-scope="option">
                            <div class="d-center">
                                {{ option.Name }}
                            </div>
                        </template>
                        <template slot="selected-option" slot-scope="option">
                            <div class="selected d-center">
                                {{ option.Name }}
                            </div>
                        </template>
                        <template #search="{attributes, events}">
                            <input
                                    class="vs__search"
                                    :required="!partner.PaymentTypeId"
                                    v-bind="attributes"
                                    v-on="events"
                                    v-on:keydown.enter.prevent
                            />
                        </template>
                    </v-select>
                </div>
            </div>
            <div class="row">
                <div class="form-group col-xl-3 col-lg-4 col-md-6">
                    <label>Дни отправки</label>
                    <v-select v-model="partner.DispatchDays" label="ShortName" :filterable="false"
                              taggable
                              multiple
                              :options="dispatchDays">
                        <template slot="no-options">
                            начните вводить...
                        </template>
                        <template slot="option" slot-scope="option">
                            <div class="d-center">
                                {{ option.ShortName }}
                            </div>
                        </template>
                        <template slot="selected-option" slot-scope="option">
                            <div class="selected d-center">
                                {{ option.ShortName }}
                            </div>
                        </template>
                    </v-select>
                </div>
            </div>
            <div class="form-group">
                <button type="submit" class="btn btn-outline-success">Сохранить</button>
            </div>
        </form>
    </div>
</template>
<script>

import {get, post, put} from '@/admin/services/api/http-utils';

const url = `${process.env.VUE_APP_API_HOST}admin/customer`;

export default {
  components: {},
  data() {
    return {
      partner: {},
      partnerTours: [],
      partnerPriceLists: [],
      dispatchDays: [],
      cities: [],
    };
  },
  async created() {
    await this.fetchPartner();
    await this.fetchPartnerTours();
    await this.fetchPartnerPriceLists();
    await this.fetchDispatchDays();
    await this.fetchCities();
  },
  methods: {
    async fetchPartner() {
      const { data } = await get(`${url}/${this.$route.params.id}`);
      this.partner = data;
    },
    async fetchPartnerTours() {
      const { data } = await get(`${process.env.VUE_APP_API_HOST}admin/tour/by-customer-group/${this.partner.CustomerGroupId}`);
      this.partnerTours = data.data;
    },
    async fetchPartnerPriceLists() {
      const { data } = await get(`${process.env.VUE_APP_API_HOST}admin/price-list`);
      this.partnerPriceLists = data.data;
    },
    async fetchDispatchDays() {
      const { data } = await get(`${process.env.VUE_APP_API_HOST}admin/order-add-form/dispatch-days`);
      this.dispatchDays = data;
    },
    async fetchCities() {
      const { data } = await get(`${process.env.VUE_APP_API_HOST}admin/city`);
      this.cities = data;
    },
    async submit() {
      await put(`${process.env.VUE_APP_API_HOST}admin/customer`, this.partner);
      this.$toasted.show('Партнер сохранен!', { type: 'success' });
      await this.fetchPartner();
    },
    async createCustomerCategory(newOption) {
      const { data } = await post(`${process.env.VUE_APP_API_HOST}admin/customer/create-customer-category`, { name: newOption });
      await this.fetchPartner();
      this.$set(this.partner, 'CustomerCategoryId', data.Id);
    },
  },
};
</script>
